/* eslint-disable import/no-cycle */
// Utils
import { attachGeneratedObjectIdToValueRecursivelyOrReturn } from './attachGeneratedObjectIdToValueRecursivelyOrReturn';
/**
 * Identify any nested objects of an array of values
 *
 * @param {any[]} value
 * @param {string} pathRelativeToParentObject
 *
 * @return {any[]}
 */
export var attachGeneratedObjectIdToValuesInArrayRecursivelyOrReturn = function (value, pathRelativeToParentObject) {
    var hasChanges = false;
    var newValue = value.map(function (valueItem) {
        var newValueItem = attachGeneratedObjectIdToValueRecursivelyOrReturn(valueItem, pathRelativeToParentObject);
        if (newValueItem !== valueItem) {
            hasChanges = true;
        }
        return newValueItem;
    });
    return hasChanges
        ? newValue
        : value;
};
//# sourceMappingURL=attachGeneratedObjectIdToValuesInArrayRecursivelyOrReturn.js.map